import React from 'react';
import { withStyles } from '@material-ui/core';
import * as moment from 'moment';
import { ReactComponent as InfoIcon } from 'assets/icons/info-fill-circle.svg';

const styles = (theme) => ({
  Note: {
    color: theme.palette.xpl.text.secondary,
    marginTop: '20px',
    fontSize: '12px',
  },
  Icon: {
    width: '12px',
    height: '12px',
    marginRight: '6px',
    verticalAlign: '-10%',
  },
});
const SuspensionRulesNote = (props) => {
  const { classes, nextAnniversaryStartDate } = props;
  return (
    <div className={classes.Note}>
      <InfoIcon className={classes.Icon} />
      Note: Remaining Suspension Period reset on{' '}
      {moment(nextAnniversaryStartDate).format('DD/MM/YYYY')}.
    </div>
  );
};

export default withStyles(styles)(SuspensionRulesNote);
